import { createCodedError } from '~/common/errors/CodedError';
import { EsignatureType } from '~/enums/EsignatureType';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type Request = {
  ticketId: Uuid;
  returnUrl: string;
  vendor: EsignatureType;
};

type Response = {
  redirectUrl: string;
};

type ServerRequest = {
  returnUrl: string;
  vendor: string;
};

type ServerResponse = {
  id: string;
  type: string;
  links: {
    sender_view: string;
  };
};

export const createEnvelope = async (request: Request): Promise<Response> => {
  try {
    const response: ServerResponse = await everest.post(
      `/tickets/${request.ticketId}/packages`,
      mapRequest(request),
    );

    return mapResponse(response);
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors[0];
      throw createCodedError({
        message: errorResponse.detail ?? errorResponse.title,
        statusCode: errorResponse.status,
        title: errorResponse.title,
      });
    }

    throw error;
  }
};

const mapRequest = (request: Request): ServerRequest => {
  return {
    returnUrl: request.returnUrl,
    vendor: request.vendor.toUpperCase(),
  };
};

const mapResponse = (serverResponse: ServerResponse): Response => {
  return {
    redirectUrl: serverResponse.links.sender_view,
  };
};
